const primary = '#0B1B25';

export default {
  primary,
}